export default __webpack_public_path__ + "static/media/klaus_crop.c2fe46b4.png";